import { type ReactNode } from 'react';
import classnames from 'classnames';

interface FormGroupProps {
  children: ReactNode;
  className?: string;
  row?: boolean;
}

const FormGroup = ({ children, className, row }: FormGroupProps) => (
  <div className={classnames('form-group', className, { row })}>{children}</div>
);

export default FormGroup;
